import { render, staticRenderFns } from "./QuoteLimitUpperRuleDia.vue?vue&type=template&id=56ea4a0f&scoped=true"
import script from "./QuoteLimitUpperRuleDia.vue?vue&type=script&lang=js"
export * from "./QuoteLimitUpperRuleDia.vue?vue&type=script&lang=js"
import style0 from "./QuoteLimitUpperRuleDia.vue?vue&type=style&index=0&id=56ea4a0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ea4a0f",
  null
  
)

export default component.exports